import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
type CountUpProps = {
  value: number;
  prefix?: string;
  suffix?: string;
  duration?: number;
};
export function CountUp({
  value,
  prefix = '',
  suffix = '',
  duration = 1600
}: CountUpProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(eased * value));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, value, duration]);
  return <span ref={ref} className="tabular-nums" data-id="element-15" data-mp="3uy31fjuyg7ou">
      {prefix}
      {display}
      {suffix}
    </span>;
}